import { NETWORK_ERROR_MESSAGES } from './NETWORK_ERROR_MESSAGES';

/**
 * @group Network
 * @summary Mapping of network error codes to user-friendly messages
 * 
 * @remarks
 * This constant maps network error codes to their corresponding user-friendly messages,
 * providing a centralized way to translate technical error codes into readable messages.
 * 
 * @example
 * ```typescript
 * import { ERROR_CODE_MESSAGES, NETWORK_ERROR_CODES } from '@shared/constants';
 * 
 * function getErrorMessage(errorCode: string): string {
 *   return ERROR_CODE_MESSAGES[errorCode] || 'An unknown error occurred';
 * }
 * 
 * const message = getErrorMessage(NETWORK_ERROR_CODES.ECONNREFUSED);
 * ```
 */
export const ERROR_CODE_MESSAGES = {
  ECONNREFUSED: NETWORK_ERROR_MESSAGES.CONNECTION_REFUSED,
  ECONNRESET: NETWORK_ERROR_MESSAGES.CONNECTION_RESET,
  ECONNABORTED: NETWORK_ERROR_MESSAGES.CONNECTION_RESET,
  ETIMEDOUT: NETWORK_ERROR_MESSAGES.CONNECTION_TIMEOUT,
  ENOTFOUND: NETWORK_ERROR_MESSAGES.DNS_LOOKUP_FAILED,
  UND_ERR_CONNECT_TIMEOUT: NETWORK_ERROR_MESSAGES.CONNECTION_TIMEOUT,
  UND_ERR_HEADERS_TIMEOUT: NETWORK_ERROR_MESSAGES.RESPONSE_TIMEOUT,
  UND_ERR_BODY_TIMEOUT: NETWORK_ERROR_MESSAGES.RESPONSE_TIMEOUT,
  FETCH_ERROR: NETWORK_ERROR_MESSAGES.CONNECTION_FAILED,
  ABORT_ERR: NETWORK_ERROR_MESSAGES.REQUEST_TIMEOUT,
  NETWORK_ERR: NETWORK_ERROR_MESSAGES.CONNECTION_FAILED,
  DB_CONNECTION_FAILED: NETWORK_ERROR_MESSAGES.DATABASE_CONNECTION_FAILED,
  DB_QUERY_TIMEOUT: NETWORK_ERROR_MESSAGES.DATABASE_TIMEOUT,
  API_RATE_LIMITED: NETWORK_ERROR_MESSAGES.RATE_LIMITED,
} as const; 